import {
  Component,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalService} from '../../services/modal.service';
import {OrderService} from '../../services/order.service';
import {AuthService} from '../../services/auth.service';
import {TranslateService} from '../../services/translate.service';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {SnackbarService} from '../../services/snackbar.service';
import {DialogButtonComponent} from '../buttons/dialog-button.component';
import {TableCodeService} from '../../services/table-code.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, LoadingSpinnerComponent, DialogButtonComponent],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-lg w-80 relative">
      <div class="p-4">
        <div class="text-xl font-medium">{{translate.getString("Ange webbkoden")}}</div>
      </div>

      <div class="px-4 pt-6 pb-2 flex flex-col items-center">
        <input
          [disabled]="sending"
          #webCodeInput
          [(ngModel)]="webcode"
          [placeholder]="translate.getString('WEBBKOD', 'upper')"
          type="text"
          (keyup)="onKeyup($event)"
          class="w-40 p-2 border rounded-xl bg-theme-surface2 text-center uppercase focus:outline-none focus:ring-2 ring-theme-primary placeholder-theme-primary-50 font-medium text-lg tracking-wider"
          >
      </div>

      <div class="h-6">
        <div *ngIf="error && !sending" class="text-center">{{translate.getString("Felaktig webbkod")}}</div>
      </div>
      <div *ngIf="sending" class="absolute bottom-10 left-0 right-0 w-full">
        <app-loading-spinner></app-loading-spinner>
      </div>

      <div class="px-4 pb-4 flex justify-end">
        <app-dialog-button [text]="translate.getString('Stäng')" (onClick)="close()"></app-dialog-button>
      </div>
    </div>
  `
})
export class WebCodeModalComponent implements OnInit, OnDestroy {
  webcode = "";
  error = false;
  sending = false;
  lastTestedCode?: string;
  @ViewChild('webCodeInput') webCodeInput!: ElementRef<HTMLInputElement>;

  constructor(private modalService: ModalService, private order: OrderService,
              private auth: AuthService, protected translate: TranslateService,
              private cdr: ChangeDetectorRef, private snackbarService: SnackbarService,
              private router: Router, private tableCodes: TableCodeService) { }

  ngOnInit() {
    console.log('Modal component initialized');
  }

  ngAfterViewInit() {
    this.webCodeInput.nativeElement.focus();
  }

  ngOnDestroy() {
    console.log('Modal component destroyed');
  }

  onKeyup(event: KeyboardEvent) {
    let code = this.webcode.toUpperCase();
    if (code.length > 5) {
      code = code.substring(0, 5);
    }
    this.webcode = code;
    console.log(this.webcode);
    this.error = false;
    if (code === "XKIOX") {
      return this.activateKioskMode();
    }
    if (code.length === 5 && this.lastTestedCode !== code) {
      this.sending = true;
      console.log(`Changing to code: ${code}`);
      this.lastTestedCode = code;
      this.order.changeTable(code).subscribe( r => {
        console.log("Changed table successfully");
        // Keep the URL in step with the table, so a reload lands on the new one (Trello 4566).
        // A query-only navigation does not re-run keepTableInUrl, so tell it about the new code
        // too, or the next navigation would put the old table back in the URL.
        this.tableCodes.urlCode = code;
        this.router.navigate([], { queryParams: { table: code }, queryParamsHandling: 'merge', replaceUrl: true });
        this.close();
      }, err => {
        console.log("API call failed:", err);
        this.error = true;
        this.sending = false;
        this.cdr.detectChanges();
      });
    }
  }

  private activateKioskMode() {
    const userCfg = this.order.getOrderOrNull()?.user_cfg;
    if (userCfg?.dt === "table" && !userCfg?.must_scan && userCfg?.is_anon) {
      this.auth.activateKioskMode().subscribe( r => {
        this.snackbarService.showMessage("Kiosk-läge aktiverat (laddar om...)", 3000);
        this.close();
        setTimeout(() => {
          location.reload();
        }, 1000);
      });
    } else {
      if (!userCfg?.is_anon) {
        this.snackbarService.showMessage("Kan inte aktivera kiosk-läge när du är inloggad", 5000);
      } else {
        this.snackbarService.showMessage("Kiosk-läge endast tillgängligt efter att du valt ett bord", 5000);
      }
    }
  }

  close() {
    this.modalService.close();
  }
}
